export function useMaxCardsToLearn() {
  return 20;
}
